export type GetShipstationQuotesPayload = {
  toCountry: string;
  toPostalCode: string;
  toState: string;
  toCity: string;
  weight: {
    units: string;
    value: number;
  };
  email: string;
  firstName: string;
  lastName: string;
  products: Array<{ sku: string; quantity: number }>;
  currency?: "usd" | "cad" | "aud";
};

export type ShipstationQuote = {
  serviceCode: string;
  serviceName: string;
  totalCost: number;
  [key: string]: any;
};

export async function getShipstationQuotes(payload: GetShipstationQuotesPayload): Promise<{
  data: ShipstationQuote[];
  error: boolean;
}> {
  const { email, firstName, lastName, products, currency = "usd", ...address } = payload;

  const res = await fetch(`${import.meta.env.VITE_WEBHOOKS_URL}/get-shipstation-quotes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...address,
      currency,
      metadata: {
        email,
        firstName,
        lastName,
        products,
      },
    }),
  });

  if (!res.ok) {
    throw new Error("Failed to fetch ShipStation quotes");
  }

  const json = await res.json();
  const data: ShipstationQuote[] = json?.data || [];

  const deduped = Object.values(
    data.reduce(
      (acc, quote) => {
        acc[quote.serviceCode] = quote;
        return acc;
      },
      {} as Record<string, ShipstationQuote>,
    ),
  );

  return {
    data: deduped,
    error: deduped.length === 0,
  };
}
